export default {
  get() {
    return Vue.http.post('qr_token').then(response => response.data.data)
  }
}
